import { createContext } from 'react'
import { CurrentHcsContextValue } from './types'

export const CurrentHcsContext = createContext<CurrentHcsContextValue>({
    currentHcs: null,
    setCurrentHcs: () => {
        throw new Error('[setCurrentUserHcs] function not yet initialized!')
    },
})
